import Alert from "nexia_mobile/models/alert";
import BaseModel from "nexia_mobile/models/base_model";
import BaseCollection from "nexia_mobile/models/base_collection";
import Editable from "nexia_mobile/models/mixins/editable";
import Platform from "nexia_mobile/platform";

class AlertCollection extends BaseCollection {
  model = Alert;

  parseLinksAcknowledge(links) {
    let link = _.first(links);
    this._acknowledgeHref = link ? link.getHref() : this._acknowledgeHref;
  }

  acknowledgeAll() {
    let model = new BaseModel();
    model.setAsEphemeral();
    model.setUrl(this._acknowledgeHref);
    return model.save(
      {},
      {
        method: "POST",
        success: () => {
          Platform.resetAppBadge();
        },
      }
    );
  }

  parseLinksClearAll(links) {
    let link = _.first(links);
    this._clearAllHref = link ? link.getHref() : this._clearAllHref;
  }

  clearAll() {
    let model = new BaseModel();
    model.setAsEphemeral();
    model.setUrl(this._clearAllHref);
    return model.save(
      {},
      {
        method: "POST",
      }
    );
  }
}

_.extend(AlertCollection.prototype, Editable);
export default AlertCollection;



// WEBPACK FOOTER //
// ./src/models/alert_collection.js